import type { FacilityDetail, PolymerGroupView } from "./types";

type ApiFetch = (path: string, init?: RequestInit) => Promise<Response>;

export function normalizeGroupName(text: string): string {
  return text.toLowerCase().replace(/[^a-z0-9]/g, "");
}

export function sortGroups<T extends { name: string }>(groups: readonly T[]): T[] {
  return [...groups].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
}

export function groupNames(groups: readonly { name: string }[]): string {
  return groups.map((g) => g.name).join(", ");
}

export async function listGroups(apiFetch: ApiFetch): Promise<PolymerGroupView[]> {
  const response = await apiFetch("facilities/groups");
  return sortGroups<PolymerGroupView>(await response.json());
}

export async function createGroup(apiFetch: ApiFetch, name: string): Promise<PolymerGroupView> {
  const response = await apiFetch("facilities/groups", { method: "POST", body: JSON.stringify({ name }) });
  return response.json();
}

export async function renameGroup(apiFetch: ApiFetch, groupId: number, name: string): Promise<PolymerGroupView> {
  const response = await apiFetch(`facilities/groups/${groupId}`, { method: "PATCH", body: JSON.stringify({ name }) });
  return response.json();
}

export async function deleteGroup(apiFetch: ApiFetch, groupId: number, force: boolean): Promise<void> {
  await apiFetch(`facilities/groups/${groupId}?force=${force}`, { method: "DELETE" });
}

export async function setFacilityGroups(
  apiFetch: ApiFetch,
  registryId: string,
  groupIds: readonly number[],
): Promise<FacilityDetail> {
  const response = await apiFetch(`facilities/${encodeURIComponent(registryId)}/groups`, {
    method: "PUT",
    body: JSON.stringify({ groupIds }),
  });
  return response.json();
}
